import _ from 'lodash';
import Button from '../form-elements/Button';
import React, {useRef } from 'react';

export function CookieSettingsButton({ children = 'Cookie-Einstellungen' }) {

    const btnRef = useRef();

    const setFocus = () => {
        btnRef.current.focus();
    };

    const handleOneTrustInformation = () => {
        if (_.isFunction(window.OneTrust?.ToggleInfoDisplay)) {
            window.OneTrust.ToggleInfoDisplay();
            window.OneTrust.OnConsentChanged(function() {
                setFocus()
            })
        }
    };
    return (
        <Button buttonRef={btnRef} modifier="link" onClick={handleOneTrustInformation}>
            {children}
        </Button>
    );
}
